import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../../environments/environment';

export interface Country {
  id: number;
  name: string;
  code: string;
  isActive: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class CountryService {
  private baseUrl = environment.apiUrl;

  constructor(private http: HttpClient) {
  }

  getCountries(): Observable<Country[]> {
    return this.http.get<Country[]>(this.baseUrl + '/commons/all-countries');
  }

  addCountry(country: Country): Observable<Country> {
    return this.http.post<Country>(this.baseUrl + '/commons/country', country);
  }

  updateCountry(country: Country): Observable<Country> {
    return this.http.put<Country>(`${this.baseUrl}/commons/country`, country);
  }

  getCountryById(id: number): Observable<Country> {
    return this.http.get<Country>(`${this.baseUrl}/commons/country/${id}`);
  }
}
